<script setup lang="ts">
const { getPathWithLocale } = useLocalizedPath()
const props = defineProps<{ to: string }>()
const localizedTo = computed(() => getPathWithLocale(props.to))
</script>

<template>
  <DropdownMenuItem as-child class="main-menu-dropdown-item">
    <NuxtLink :to="localizedTo" class="main-menu-regular-link">
      <slot />
    </NuxtLink>
  </DropdownMenuItem>
</template>
